(() => {
  'use strict';
  const country=document.body.dataset.fpMarket;
  if(!['AE','ZA'].includes(country)||window.FocusPodCheckout)return;
  const source=document.getElementById('fp-us-engine-source')?.content.querySelector('[data-builder-data]');
  if(!source)return;
  const data=JSON.parse(source.textContent);
  const tiers=[{minimum:2,basisPoints:300},{minimum:3,basisPoints:500},{minimum:5,basisPoints:750}];
  function projectPricing(designs,calculate){
    if(!Array.isArray(designs)||designs.length>20)throw new Error('Review your project configurations.');
    const configurations=designs.map(selection=>{
      if(!Number.isSafeInteger(selection.quantity)||selection.quantity<1||selection.quantity>100)throw new Error('Review your pod quantity.');
      const total=calculate(selection),pod=total.lines.find(line=>line.code==='pod');
      if(!pod||!Number.isSafeInteger(pod.priceCents)||!Number.isSafeInteger(total.subtotalCents))throw new Error('Refresh the configurator to check the current price.');
      return {quantity:selection.quantity,podPriceCents:pod.priceCents,subtotalCents:total.subtotalCents};
    });
    const quantity=configurations.reduce((sum,item)=>sum+item.quantity,0);
    if(quantity>100)throw new Error('A project can contain up to 100 pods.');
    const tier=[...tiers].reverse().find(item=>quantity>=item.minimum),basisPoints=tier?.basisPoints||0;
    const configurationSavings=configurations.map(item=>Math.round(item.podPriceCents*basisPoints/10000/100)*100*item.quantity);
    const originalTotal=configurations.reduce((sum,item)=>sum+item.subtotalCents,0),savingCents=configurationSavings.reduce((sum,value)=>sum+value,0);
    return {originalTotal,total:originalTotal-savingCents,volume:{quantity,percentage:basisPoints/100,savingCents,configurationSavings},bankSavingCents:0,bankTotalCents:originalTotal-savingCents};
  }
  window.FocusPodCheckout=Object.freeze({projectPricing,multiPodTiers:true,quoteOnly:true});
})();

